import { createLogger } from '@repo/utility/logging';
import { isAdPreviewMode } from '@repo/wemod-api-client/analytics/ad-preview-cookie';

const logger = createLogger({
    environment: 'development',
    color: 'orange',
    prefix: 'Ads',
});

function isAdLifecycleLoggingEnabled(): boolean {
    const env = process.env.NEXT_PUBLIC_WRANGLER_ENV ?? process.env.NODE_ENV ?? 'production';
    if (env.toLowerCase() !== 'production') {
        return true;
    }
    if (typeof document !== 'undefined' && isAdPreviewMode(document.cookie)) {
        return true;
    }
    return false;
}

export function logAdLifecycle(step: string, data?: Record<string, unknown>): void {
    if (!isAdLifecycleLoggingEnabled()) {
        return;
    }
    logger.info(step, data);
}

export function logAdLifecycleWarn(step: string, data?: Record<string, unknown>): void {
    if (!isAdLifecycleLoggingEnabled()) {
        return;
    }
    logger.warn(step, data);
}

export function logAdLifecycleError(step: string, data?: Record<string, unknown>): void {
    if (!isAdLifecycleLoggingEnabled()) {
        return;
    }
    logger.error(step, data);
}
